export const ONBOARDING_STEPS = [
  'goal',
  'experience',
  'business_profile',
  'personalize',
  'call_recording',
  'goal_setup',
  'review',
  'phone_number',
  'first_call',
];

export const GOALS = [
  { id: 'message', title: 'Take complete messages', description: 'Capture who called, why, and how to follow up.' },
  { id: 'appointment', title: 'Book appointments', description: 'Help callers find a time and capture booking details.' },
  { id: 'routing', title: 'Route or transfer calls', description: 'Connect callers to the right person with a fallback.' },
  { id: 'faq', title: 'Answer common questions', description: 'Handle hours, services, location, and routine questions.' },
  { id: 'custom', title: 'Custom: send to your own system', description: 'Send caller information to Salesforce, Asana, HubSpot, Microsoft Dynamics, or another supported system.' },
];

export const EXPERIENCES = [
  { id: 'first_time', title: 'This is my first one', description: 'We’ll explain each decision as we go.' },
  { id: 'experienced', title: 'I’ve used one before', description: 'We’ll keep setup focused and concise.' },
  { id: 'switching', title: 'I’m replacing another service', description: 'We’ll prioritize a smooth handoff.' },
];

export const CALL_RECORDING_CHOICES = [
  {
    id: 'enabled',
    title: 'Yes, record calls',
    description: 'Keep an audio record so your team can review conversations and follow-up details.',
  },
  {
    id: 'disabled',
    title: 'Not now',
    description: 'Calls will still have summaries and transcripts without saved audio.',
  },
];

export function stepProgress(stepKey, steps = ONBOARDING_STEPS) {
  const index = Math.max(steps.indexOf(stepKey), 0);
  return {
    index,
    number: index + 1,
    total: steps.length,
    percent: Math.round(((index + 1) / steps.length) * 100),
  };
}
